import type { ReactNode } from 'react';
import React, { createContext, useContext } from 'react';

import type { SyteClient } from './types';

interface ApiContextType {
  fetchData: SyteClient;
  organizationId: string | null;
  organizationName: string;
  loggedUser: string;
  mockedData?: boolean;
  userIsCollaborator: boolean;
  userIsProspect: boolean;
  userIsReadOnly: boolean;
  prospectExpired: boolean;
  prospectDaysRemaining: number;
  isUnifiedPortal: boolean;
}

const ApiContext = createContext<ApiContextType | undefined>(undefined);

export const useSyteApi = (): ApiContextType => {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error('useApi must be used within an ApiProvider');
  }
  return context;
};

export const SyteApiProvider: React.FC<{
  value: ApiContextType;
  children: ReactNode;
}> = ({ value, children }) => {
  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
};
